var getAppearanceClasses = function getAppearanceClasses(value) {
  switch (value) {
    case 'primary':
      return 'yt-blue-solid';

    case 'danger':
      return 'yt-red-solid';

    case 'ghost':
      return 'yt-blue-inverted';

    case 'discrete':
      return 'yt-transparent';

    case 'default':
    default:
      return 'yt-grey-solid';
  }
};
var getStateClasses = function getStateClasses(value) {
  switch (value) {
    case 'information':
      return 'yt-blue-solid';

    case 'warning':
      return 'yt-yellow-solid';

    case 'error':
      return 'yt-red-solid';

    case 'success':
      return 'yt-green-solid';

    case 'default':
    default:
      return 'yt-grey-solid';
  }
};
var getOutlineClasses = function getOutlineClasses(state) {
  switch (state) {
    case 'information':
    case 'primary':
      return 'yt-blue-inverted';

    case 'warning':
      return 'yt-yellow-inverted';

    case 'error':
    case 'danger':
      return 'yt-red-inverted';

    case 'success':
      return 'yt-green-inverted';

    case 'default':
    default:
      return 'yt-grey-inverted';
  }
};

export { getAppearanceClasses, getOutlineClasses, getStateClasses };
//# sourceMappingURL=taillwind.js.map
